import styled from 'styled-components'

export const Content = styled.div`
  background: #FFF;
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05), 0px 6px 12px rgba(61, 69, 67, 0.05);

  width: 100%;
  padding: 30px 25px;
  margin-bottom: 10px;

  > strong {
    text-align: center;
    font-size: 18px;
    color: ${props => props.theme.colors.primary};

    display: flex;
    justify-content: center;
    margin-bottom: 15px;
  }

  form {
    width: 100%;
  }

  > p {
    text-align: center;
    margin-bottom: 15px;
  }

  @media screen and (max-width: 766px) {
    padding: 20px 15px;
  }
`

export const InfoContent = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;

  input[type=checkbox]{
    accent-color:  #00793A;
    margin-right: 4px;

    &:focus, &:hover {
      box-shadow: 0 0 2px 0.1rem rgba(101, 172, 30, .25);
    }
  }

  span.error {
    font-size: 12px;
    color: ${props => props.theme.colors.error};
    background: #fce8e8;
    padding: 4px 12px;
    margin-top: 8px;
    border-radius: 4px;
    width: fit-content;
  }

  > div.infoSimple {
    display: flex;
    justify-content: start;
    align-items: center;

    width: 100%;
    margin: 12px 0 0;
    z-index: 0;

    small {
      font-size: 12px;
    }
  }

  > div.infoTotal {
    display: flex;
    justify-content: space-between;
    align-items: center;

    width: 100%;
    margin: 12px 0 0;

    strong {
      font-size: 16px;
      color:${props => props.theme.colors.primary}
    }

    small {
      font-size: 12px;
    }
  }

  @media screen and (max-width: 600px) {
    > div {
      p {
        width: 70%;
      }
    }
  }
`

export const UPContentSlider = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  > p {
    padding-bottom: 16px;
  }
`

export const UPBoxSlider = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  width: 100%;
  height: auto;
  padding: 0px 4px 16px 16px;
  margin: 2px 0;

  /* border: 1px solid #D9DADD;
  border-radius: 4px; */

  div.UR-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-around;
    width: 150px;

    p {
      text-align: left;
    }

    small {
      font-size: 11px;
      color: ${props => props.theme.colors.placeholder};
      text-align: left;
    }
  }

  > strong {
    justify-content: right;
    position: relative;
    width: 60px;
    height: 100%;
    margin: 0 0 12px 32px;
    padding: 8px;
    border-radius: 8px;
    border: solid 1px #D9DADD;
    font-size: 14px;
      color: #333333;
    /* background: lavender; */
  }

  > div {
    height: 100%;
    width: inherit;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  @media screen and (max-width: 500) {
    flex-direction: column;
    align-content: center;

    padding: 5px;
    height: 100%;

    > strong {
      margin: 0px !important;
      width: 50% !important;
    }

    div.UR-info {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      margin-bottom: 5px;

      small {
        font-size: 11px;
        color: ${props => props.theme.colors.placeholder};
      }
    }

    > strong {
      width: 100%;
      text-align: center;
      justify-content: center;
    }
  }
`

export const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;

  p {
    margin-bottom: 8px;
    font-size: 12px;
    line-height: 14px;
    color:${props => props.theme.colors.text}
  }
`
